var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table",staticStyle:{"height":"100%","box-sizing":"border-box"}},[_c('a-spin',{attrs:{"tip":"Loading...","spinning":_vm.loading}},[_c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('ag-grid-vue',{staticClass:"ag-theme-alpine",style:({
          width: _vm.width,
          height:
            _vm.count === 1
              ? '9rem'
              : _vm.count === 2
              ? '13rem'
              : _vm.count === 3
              ? '16rem'
              : _vm.count === 4 || _vm.count > 4
              ? '20rem'
              : '11rem'
        }),attrs:{"id":"estimateInfoTable","gridOptions":_vm.gridOptions,"columnDefs":_vm.columnDefs,"frameworkComponents":_vm.frameworkComponents,"animateRows":true,"suppressLoadingOverlay":"true"},on:{"grid-ready":_vm.getData}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }